import { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Tooltip } from "@wordpress/components";
import { __ } from "@wordpress/i18n";
import { Docs } from "@DashboardApp/pages";

const DocsPopup = () => {
	const [open, setOpen] = useState(false);
	const kbData = astra_admin.astra_docs_data && astra_admin.astra_docs_data?.categories;
	const docsTrigger = () => {
		if ( kbData ) {
			setOpen(true);
		} else {
			window.open( "https://wpastra.com/docs/", '_blank' );
		}
	};
	return (
		<div>
			<Tooltip text={__('Knowledge Base', 'astra')} delay={50}>
				<div className="w-8 sm:w-10 h-8 sm:h-10 flex items-center whitespace-nowrap justify-center cursor-pointer rounded-full border border-slate-200">
					<a onClick={docsTrigger} className="text-xs sm:text-sm font-medium sm:leading-[0.875rem] text-slate-600 doc-icon">
						<svg width="30" height="30" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
							<rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill="white" />
							<path d="M16 11.0347C14.6731 9.84713 12.9209 9.125 11 9.125C10.1234 9.125 9.28195 9.27539 8.5 9.55176V21.4268C9.28195 21.1504 10.1234 21 11 21C12.9209 21 14.6731 21.7221 16 22.9097M16 11.0347C17.3269 9.84713 19.0791 9.125 21 9.125C21.8766 9.125 22.7181 9.27539 23.5 9.55176V21.4268C22.7181 21.1504 21.8766 21 21 21C19.0791 21 17.3269 21.7221 16 22.9097M16 11.0347V22.9097" stroke="#475569" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
						<span className="sr-only">{__('Knowledge Base', 'astra')}</span>
					</a>
				</div>
			</Tooltip>

			{kbData && (
				<Transition.Root show={open} as={Fragment}>
					<Dialog
						as="div"
						className="relative z-10"
						onClose={setOpen}
					>
						<div className="fixed inset-0 top-8 z-10 overflow-y-auto ast-kb-section">
							<div className="flex min-h-screen h-full items-end justify-center p-4 text-center sm:items-center sm:p-0 ast-kb-inner-wrap">
								<Transition.Child
									as={Fragment}
									enter="ease-out duration-300"
									enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
									enterTo="opacity-100 translate-y-0 sm:scale-100"
									leave="ease-in duration-200"
									leaveFrom="opacity-100 translate-y-0 sm:scale-100"
									leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
								>
									<Dialog.Panel className="relative transform bg-white text-left transition-all min-h-screen w-full h-full lg:ml-40">
										<Docs setOpen={setOpen} />
									</Dialog.Panel>
								</Transition.Child>
							</div>
						</div>
					</Dialog>
				</Transition.Root>
			)}
		</div>
	);
};

export default DocsPopup;
